/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { ReactComponent as BottomSavedImage } from './svgs/bottomSavedImage.svg';

const DadJokeSavedImageBottomBg = () => {
    return (
        <BottomSavedImage />
    );
};

export default DadJokeSavedImageBottomBg;